
export const common = {
  nav: {
    home: '首頁',
    wms: {
      title: 'WMS倉庫系統',
      ecommerce: '電商物流WMS',
      thirdParty: '第三方物流WMS'
    },
    ecommerce_wms: '電商物流WMS',
    logistics_wms: '第三方物流WMS',
    tms: 'TMS運輸系統',
    about: '關於我們',
    contact: '聯絡我們',
    language: '中',
  },
  hero: {
    title: '智能物流解決方案',
    subtitle: '引領未來的倉庫管理與運輸系統',
    description: 'AUTOCHAIN 提供先進的 WMS 和 TMS 系統，幫助企業實現智能化物流管理，提升效率，降低成本。',
    cta: '立即體驗',
    cta1: '免費獲取方案',
    cta2: '預約演示',
    demo: '預約演示',
  },
  painPoints: {
    title: '您是否正面臨這些物流挑戰？',
    warehouse: {
      title: '倉儲管理痛點',
      pain1: '庫存數據不準確，經常出現缺貨或積壓',
      pain2: '人工作業效率低，容易出錯',
      pain3: '無法實時追蹤貨物位置和狀態',
      pain4: '倉庫空間利用率不高，成本居高不下',
    },
    transport: {
      title: '運輸管理痛點',
      pain1: '無法實時掌握車輛位置和運輸狀態',
      pain2: '路線規劃不合理，增加運輸成本',
      pain3: '司機管理困難，薪酬計算複雜',
    },
    solution: '✅ AUTOCHAIN 智能物流系統為您解決所有痛點！',
  },
  products: {
    title: '我們的解決方案',
    subtitle: '專業的 WMS 和 TMS 系統，為您的物流業務提供全方位支持',
    wms: {
      title: 'WMS 倉庫管理系統',
      description: '智能化倉庫管理，提升庫存精確度和作業效率',
      benefit: '✅ 提升 40% 倉庫作業效率，庫存準確率達 99.9%',
      cta: '了解 WMS 系統',
    },
    tms: {
      title: 'TMS 運輸管理系統',
      description: '優化運輸路線，降低物流成本，提升配送效率',
      benefit: '✅ 節省 30% 運輸成本，提升客戶滿意度',
      cta: '了解 TMS 系統',
    },
  },
  integration: {
    title: 'WMS + TMS 整合威力',
    effect: '1 + 1 > 2 的協同效應',
    description: '當 WMS 和 TMS 系統完美整合時，您的物流業務將實現前所未有的效率提升。從訂單接收到最終配送，每個環節都能無縫銜接，為您創造更大的商業價值。',
    steps: {
      step1: {
        title: '訂單接收',
        desc: '自動接收並分析訂單',
      },
      step2: {
        title: 'WMS 處理',
        desc: '智能分配庫存和揀貨',
      },
      step3: {
        title: 'TMS 調度',
        desc: '優化路線和車輛安排',
      },
      step4: {
        title: '客戶通知',
        desc: '實時更新配送狀態',
      },
    },
  },
  features: {
    title: '核心功能',
    subtitle: '全方位智能物流管理',
    wms: {
      title: 'WMS 倉庫管理系統',
      description: '智能化倉庫管理，提升庫存精確度和作業效率',
    },
    tms: {
      title: 'TMS 運輸管理系統',
      description: '優化運輸路線，降低物流成本，提升配送效率',
    },
    ai: {
      title: 'AI 智能分析',
      description: '運用人工智能技術，預測需求，優化庫存配置',
    },
  },
  benefits: {
    title: '為什麼選擇 AUTOCHAIN',
    subtitle: '專業的物流技術解決方案',
    efficiency: '提升效率',
    efficiencyDesc: '自動化流程減少人工錯誤，提升 40% 作業效率',
    cost: '降低成本',
    costDesc: '優化庫存管理和運輸路線，節省 30% 營運成本',
    accuracy: '精確管理',
    accuracyDesc: '實時追蹤和數據分析，庫存準確率達 99.9%',
    support: '專業支援',
    supportDesc: '24/7 技術支援，確保系統穩定運行',
  },
  testimonials: {
    title: '客戶見證',
    subtitle: '看看我們的客戶怎麼說',
    customer1: {
      name: '張經理',
      role: 'CaseTify 物流總監',
      quote: '使用 AUTOCHAIN 的 WMS 系統後，我們的庫存準確率提升到 99.8%，大大減少了缺貨情況。',
    },
    customer2: {
      name: '李總監',
      role: '奇華餅家 營運總監',
      quote: 'TMS 系統幫助我們優化了配送路線，運輸成本降低了 25%，客戶滿意度也大幅提升。',
    },
    customer3: {
      name: '王主管',
      role: 'San-Legend Global 倉庫主管',
      quote: '整合的 WMS+TMS 解決方案讓我們的物流作業更加順暢，效率提升了 40%。',
    },
  },
  howItWorks: {
    title: '如何開始',
    subtitle: '簡單四步，開啟您的智能物流之旅',
    step1: '需求分析',
    step1Desc: '我們的專家團隊深入了解您的業務需求',
    step2: '方案設計',
    step2Desc: '為您量身定制最適合的物流解決方案',
    step3: '系統部署',
    step3Desc: '快速部署系統，提供全面的培訓支援',
    step4: '持續優化',
    step4Desc: '持續監控和優化，確保最佳效果',
    description: '我們的專業團隊將全程陪伴您，確保系統順利上線並發揮最大效益。',
    cta: '立即開始',
  },
  partners: {
    title: '信賴夥伴',
    subtitle: '眾多知名企業選擇 AUTOCHAIN',
  },
  finalCta: {
    title: '準備開始您的智能物流之旅？',
    description: '立即聯絡我們，獲得專業的物流解決方案諮詢，讓您的業務更上一層樓。',
    requirements: '我們只需要以下基本資訊：',
    req1: '聯絡人姓名',
    req2: '聯絡電話',
    req3: '公司名稱',
    contact: '或直接致電：+852 9425 2903',
  },
  contactForm: {
    title: '聯絡我們',
    subtitle: '填寫表單，我們將在 24 小時內與您聯絡',
    name: '姓名',
    namePlaceholder: '請輸入您的姓名',
    company: '公司名稱',
    companyPlaceholder: '請輸入公司名稱',
    email: '電子郵件',
    emailPlaceholder: '請輸入電子郵件',
    phone: '聯絡電話',
    phonePlaceholder: '請輸入聯絡電話',
    message: '需求描述',
    messagePlaceholder: '請描述您的具體需求...',
    submit: '提交諮詢',
    submitSuccess: '提交成功！我們將在 24 小時內與您聯絡。',
    submitError: '提交失敗，請稍後再試或直接致電聯絡我們。',
  },
  cta: {
    title: '準備開始您的智能物流之旅？',
    subtitle: '立即聯絡我們，獲得專業的物流解決方案諮詢',
    button: '免費諮詢',
  },
  footer: {
    company: 'AUTOCHAIN TECHNOLOGY',
    description: '專業的智能物流解決方案提供商',
    quickLinks: '快速連結',
    contact: '聯絡資訊',
    address: '香港九龍觀塘區',
    phone: '+852 9425 2903',
    email: 'info@autochain.tech',
    copyright: '© 2024 AUTOCHAIN TECHNOLOGY. 保留所有權利。',
  },
};
